export default {"src":"/_next/static/media/renting-to-owning.ec806c06.svg","height":184,"width":184};